import { render } from "./letter-pattern-list.vue?vue&type=template&id=2c373d5b"
import script from "./letter-pattern-list.vue?vue&type=script&lang=js"
export * from "./letter-pattern-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__